import { ResponseMapper } from '../../utils/httpclient/response/responsemapper';
import { Logger, LogManager } from '../../utils/logger/logger';
import { RemoveFromBlacklistRequest } from '../api/blacklist/removefromblacklist/removefromblacklistrequest';
import { RemoveFromBlacklistResponse, RemoveFromBlacklistResponseDtoImpl } from '../api/blacklist/removefromblacklist/removefromblacklistresponse';
import { APIFeatures } from '../util/apifeatures';
import { StatusCodes } from '../util/statuscodes';
import { SixdeeCRBTAPIProcessor } from './sixdeecrbtapiprocessor';
import { Strings } from '../../utils/resources/strings';

export class RemoveFromBlacklistAPIProcessorImpl extends SixdeeCRBTAPIProcessor<RemoveFromBlacklistRequest, RemoveFromBlacklistResponse>
{
    private LOGGER: Logger = LogManager.getLogger(RemoveFromBlacklistAPIProcessorImpl.name);
    execute(request: RemoveFromBlacklistRequest): void {
        super.execute(request);
    }

    onSuccess(responseMapper: ResponseMapper): void 
    {
        this.LOGGER.log("onSuccess() invoked");

        super.onSuccess(responseMapper);
        try {

            if (+responseMapper.getStatusCode() === StatusCodes.SUCCESS) {

                let response = new RemoveFromBlacklistResponseDtoImpl(APIFeatures.REMOVE_FROM_BLACKLIST, "Remove From Blacklist Success");

                this.getAPISuccess(response);
            }
        }
        catch (e) {
            this.getAPIFailure(new RemoveFromBlacklistResponseDtoImpl(APIFeatures.REMOVE_FROM_BLACKLIST, this.getContext().getResources().getString(Strings.internal_server_error)));
        }
    }

    onFailure(responseMapper: ResponseMapper): void 
    {
        super.onFailure(responseMapper);

            this.getAPIFailure(new RemoveFromBlacklistResponseDtoImpl(APIFeatures.REMOVE_FROM_BLACKLIST,responseMapper.getStatusMsg()));
        
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/processor/removefromblacklistapiprocessor.tsx